// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectNewsSubscribeResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_NEWS_SUBSCRIBE_RESPONSE);
        this.RouteIdsArr = [];
    }
}
